import * as types from "../actions/types/businessRegistration.types";

const initialState = {
    fetchSubmittedRecordsState: "idle",
    submittedRecords: null,
    fetchSavedRecordsState: "idle",
    savedRecords: null,
    fetchCompletedRecordsState: "idle",
    completedRecords: null,
    lookup: null,
    fetchLookupState: "idle",
    companyLookup: null,
    fetchCompanyLookupState: "idle",
    stateLookup: null,
    fetchStateLookupState: "idle",
    lgaLookup: null,
    fetchLgaLookupState: "idle"
};

export const businessRegistration = (state = initialState, action) => {
    switch (action.type) {
        case types.FETCH_SUBMITTED_RECORDS_STARTED:
            return {
                ...state,
                fetchSubmittedRecordsState: "loading",
            };

        case types.FETCH_SUBMITTED_RECORDS_SUCCESS: {
            return {
                ...state,
                fetchSubmittedRecordsState: "success",
                submittedRecords: action.payload,
            };
        }

        case types.FETCH_SUBMITTED_RECORDS_FAILED: {
            return {
                ...state,
                fetchSubmittedRecordsState: "failed",
            };
        }


        case types.FETCH_SAVED_RECORDS_STARTED:
            return {
                ...state,
                fetchSavedRecordsState: "loading",
            };

        case types.FETCH_SAVED_RECORDS_SUCCESS: {
            return {
                ...state,
                fetchSavedRecordsState: "success",
                savedRecords: action.payload,
            };
        }

        case types.FETCH_SAVED_RECORDS_FAILED: {
            return {
                ...state,
                fetchSavedRecordsState: "failed",
            };
        }

    
        case types.FETCH_COMPLETED_RECORDS_STARTED:
            return {
                ...state,
                fetchCompletedRecordsState: "loading",
            };

        case types.FETCH_COMPLETED_RECORDS_SUCCESS: {
            return {
                ...state,
                fetchCompletedRecordsState: "success",
                completedRecords: action.payload,
            };
        }

        case types.FETCH_COMPLETED_RECORDS_FAILED: {
            return {
                ...state,
                fetchCompletedRecordsState: "failed",
            };
        }


        case types.FETCH_LOOKUP_DATA_STARTED:
            return {
                ...state,
                fetchLookupState: "loading",
            };

        case types.FETCH_LOOKUP_DATA_SUCCESS: {
            return {
                ...state,
                fetchLookupState: "success",
                lookup: action.payload,
            };
        }

        case types.FETCH_LOOKUP_DATA_FAILED: {
            return {
                ...state,
                fetchLookupState: "failed",
            };
        }

        case types.FETCH_COMPANY_LOOKUP_DATA_STARTED:
            return {
                ...state,
                fetchCompanyLookupState: "loading",
            };

        case types.FETCH_COMPANY_LOOKUP_DATA_SUCCESS: {
            return {
                ...state,
                fetchCompanyLookupState: "success",
                companyLookup: action.payload,
            };
        }

        case types.FETCH_COMPANY_LOOKUP_DATA_FAILED: {
            return {
                ...state,
                fetchCompanyLookupState: "failed",
            };
        }

        case types.FETCH_STATE_LOOKUP_DATA_STARTED:
            return {
                ...state,
                fetchStateLookupState: "loading",
            };

        case types.FETCH_STATE_LOOKUP_DATA_SUCCESS: {
            return {
                ...state,
                fetchStateLookupState: "success",
                stateLookup: action.payload,
            };
        }

        case types.FETCH_STATE_LOOKUP_DATA_FAILED: {
            return {
                ...state,
                fetchStateLookupState: "failed",
            };
        }

        case types.FETCH_LGA_LOOKUP_DATA_STARTED:
            return {
                ...state,
                fetchLgaLookupState: "loading",
            };

        case types.FETCH_LGA_LOOKUP_DATA_SUCCESS: {
            return {
                ...state,
                fetchLgaLookupState: "success",
                lgaLookup: action.payload,
            };
        }

        case types.FETCH_LGA_LOOKUP_DATA_FAILED: {
            return {
                ...state,
                fetchLgaLookupState: "failed",
            };
        }

        default:
            return state;
    }
};





// BR means Business Registration
// BN means Business Name registration
// LLC means Company registration

// export function BizRegErrorReducer(state = {}, type, payload) {
//     switch (type) {
//         case types.BUSINESS_REG_ERROR:
//             return {
//                 initialState: { ...state },
//                 state: "failed",
//                 message: payload?.message,
//                 error: payload?.error,
//             };
//         case types.RESET_BUSINESS_REG_ERROR:
//             return { initialState: state };
//         default:
//             return state;
//     }
// }

// export function FetchBNApplicationReducer(
//     initialState = { data: null, message: "", error: [], state: "idle" },
//     { type, payload },
// ) {
//     switch (type) {
//         case types.FETCH_BN_APPLICATION_STARTED:
//             return {
//                 ...initialState,
//                 state: "loading",
//             };
//         case types.FETCH_BN_APPLICATION_SUCCESS:
//             return {
//                 ...initialState,
//                 state: "success",
//                 data: payload?.data,
//             };
//         case types.FETCH_BN_APPLICATION_FAILED:
//             return {
//                 ...initialState,
//                 state: "failed",
//                 message: payload?.message || "",
//             };
//         case types.FETCH_BN_APPLICATION_RESET:
//         default:
//             return initialState;
//     }
// }

// export function CancelApplicationReducer(
//     initialState = { data: {}, message: "", error: [], state: "idle" },
//     { type, payload },
// ) {
//     switch (type) {
//         case types.CANCEL_APPLICATION_STARTED:
//             return {
//                 ...initialState,
//                 state: "loading",
//             };
//         case types.CANCEL_APPLICATION_SUCCESS:
//             return {
//                 ...initialState,
//                 state: "success",
//                 data: payload?.data,
//             };
//         case types.CANCEL_APPLICATION_FAILED:
//             return BizRegErrorReducer(initialState, (type = "CANCEL_APPLICATION_FAILED"), payload);
//         default:
//             return initialState;
//     }
// }

// export function FetchLlcApplicationReducer(
//     initialState = { data: {}, message: "", error: [], state: "idle" },
//     { type, payload },
// ) {
//     switch (type) {
//         case types.FETCH_LLC_APPLICATION_STARTED:
//             return {
//                 ...initialState,
//                 state: "loading",
//             };
//         case types.FETCH_LLC_APPLICATION_SUCCESS:
//             return {
//                 ...initialState,
//                 state: "success",
//                 data: payload?.data,
//             };
//         case types.FETCH_LLC_APPLICATION_FAILED:
//             return BizRegErrorReducer(
//                 initialState,
//                 (type = "FETCH_LLC_APPLICATION_FAILED"),
//                 payload,
//             );
//         default:
//         case types.FETCH_LLC_APPLICATION_RESET:
//             return initialState;
//     }
// }

// export function VerifyBRPaymentReducer(
//     initialState = { data: {}, message: "", error: [], state: "idle" },
//     { type, payload },
// ) {
//     switch (type) {
//         case types.VERIFY_PAYMENT_STARTED:
//             return {
//                 ...initialState,
//                 state: "loading",
//             };
//         case types.VERIFY_PAYMENT_SUCCESS:
//             return {
//                 ...initialState,
//                 state: "success",
//                 data: payload?.data,
//             };
//         case types.VERIFY_PAYMENT_FAILED:
//             return BizRegErrorReducer(initialState, (type = "VERIFY_PAYMENT_FAILED"), payload);
//         default:
//             return initialState;
//     }
// }

// export function BROnboardingReducer(
//     initialState = { data: {}, message: "", error: [], state: "idle" },
//     { type, payload },
// ) {
//     switch (type) {
//         case types.ONBOARDING_STARTED:
//         case types.FETCH_ONBOARDING_STARTED:
//             return {
//                 ...initialState,
//                 state: "loading",
//             };
//         case types.ONBOARDING_SUCCESS:
//         case types.FETCH_ONBOARDING_SUCCESS:
//             return {
//                 ...initialState,
//                 state: "success",
//                 data: payload?.data,
//             };
//         case types.ONBOARDING_FAILED:
//             return {
//                 ...initialState,
//                 state: "failed",
//             };
//         case types.FETCH_ONBOARDING_FAILED:
//             return {
//                 ...initialState,
//                 state: "failed",
//                 data: {},
//             };

//         case types.FETCH_ONBOARDING_RESET:
//         default:
//             return initialState;
//     }
// }

// export function BRInitializationReducer(
//     initialState = { data: {}, message: "", error: [], state: "idle" },
//     { type, payload },
// ) {
//     switch (type) {
//         case types.APPLICATION_INIT_STARTED:
//             return {
//                 ...initialState,
//                 state: "loading",
//             };
//         case types.APPLICATION_INIT_SUCCESS:
//             return {
//                 ...initialState,
//                 state: "success",
//                 data: payload?.data,
//             };
//         case types.APPLICATION_INIT_FAILED:
//             return BizRegErrorReducer(initialState, (type = "APPLICATION_INIT_FAILED"), payload);
//         default:
//             return initialState;
//     }
// }

// export function UpdateBnRegistrationReducer(
//     initialState = { data: {}, message: "", error: [], state: "idle" },
//     { type, payload },
// ) {
//     switch (type) {
//         case types.UPDATE_BN_STARTED:
//             return {
//                 ...initialState,
//                 state: "loading",
//             };
//         case types.UPDATE_BN_SUCCESS:
//             return {
//                 ...initialState,
//                 state: "success",
//                 data: payload?.data,
//             };
//         case types.UPDATE_BN_FAILED:
//             return {
//                 ...initialState,
//                 state: "failed",
//             };
//         default:
//             return initialState;
//     }
// }

// export function UpdateLlcRegistrationReducer(
//     initialState = { data: {}, message: "", error: [], state: "idle" },
//     { type, payload },
// ) {
//     switch (type) {
//         case types.UPDATE_LLC_STARTED:
//             return {
//                 ...initialState,
//                 state: "loading",
//             };
//         case types.UPDATE_LLC_SUCCESS:
//             return {
//                 ...initialState,
//                 state: "success",
//                 data: payload?.data,
//             };
//         case types.UPDATE_LLC_FAILED:
//             return {
//                 ...initialState,
//                 state: "failed",
//             };
//         default:
//             return initialState;
//     }
// }

// export function UploadBRDocumentReducer(
//     initialState = { data: null, message: "", error: [], state: "idle" },
//     { type, payload },
// ) {
//     switch (type) {
//         case types.UPLOAD_DOCUMENT_STARTED:
//             return {
//                 ...initialState,
//                 state: "loading",
//             };
//         case types.UPLOAD_DOCUMENT_SUCCESS:
//             return {
//                 ...initialState,
//                 state: "success",
//                 data: payload?.data,
//             };
//         case types.UPLOAD_DOCUMENT_FAILED:
//             return BizRegErrorReducer(initialState, (type = "UPLOAD_DOCUMENT_FAILED"), payload);
//         case types.FETCH_DOCUMENT_STARTED:
//             return {
//                 ...initialState,
//                 state: "loading",
//             };
//         case types.FETCH_DOCUMENT_SUCCESS:
//             return {
//                 ...initialState,
//                 state: "success",
//                 data: payload?.data,
//             };
//         case types.FETCH_DOCUMENT_FAILED:
//             return BizRegErrorReducer(
//                 initialState,
//                 (type = "FETCH_BN_APPLICATION_FAILED"),
//                 payload,
//             );
//         default:
//         case types.FETCH_DOCUMENT_RESET:
//             return initialState;
//     }
// }

// export function InitiateBRPaymentReducer(
//     initialState = { data: {}, message: "", error: [], state: "idle" },
//     { type, payload },
// ) {
//     switch (type) {
//         case types.INITIATE_PAYMENT_STARTED:
//             return {
//                 ...initialState,
//                 state: "loading",
//             };
//         case types.INITIATE_PAYMENT_SUCCESS:
//             return {
//                 ...initialState,
//                 state: "success",
//                 data: payload?.data,
//             };
//         case types.INITIATE_PAYMENT_FAILED:
//             return BizRegErrorReducer(initialState, (type = "INITIATE_PAYMENT_FAILED"), payload);
//         default:
//             return initialState;
//     }
// }

// export function SendBusinessEmailOtpReducer(
//     initialState = { data: {}, message: "", error: "", state: "idle" },
//     { type, payload },
// ) {
//     switch (type) {
//         case types.SEND_OTP_FOR_BUSINESS_EMAIL_STARTED:
//             return {
//                 ...initialState,
//                 state: "loading",
//             };
//         case types.SEND_OTP_FOR_BUSINESS_EMAIL_SUCCESS:
//             return {
//                 ...initialState,
//                 data: payload?.data,
//                 state: "success",
//             };
//         case types.SEND_OTP_FOR_BUSINESS_EMAIL_FAILED:
//             return {
//                 ...initialState,
//                 state: "failed",
//                 message: payload?.message,
//                 error: payload?.error,
//             };
//         default:
//             return initialState;
//     }
// }

// export function VerifyBusinessEmailOtpReducer(
//     initialState = { data: {}, message: "", error: "", state: "idle" },
//     { type, payload },
// ) {
//     switch (type) {
//         case types.VERIFY_OTP_FOR_BUSINESS_EMAIL_STARTED:
//             return {
//                 ...initialState,
//                 state: "loading",
//             };
//         case types.VERIFY_OTP_FOR_BUSINESS_EMAIL_SUCCESS:
//             return {
//                 ...initialState,
//                 data: payload?.data,
//                 state: "success",
//             };
//         case types.VERIFY_OTP_FOR_BUSINESS_EMAIL_FAILED:
//             return {
//                 ...initialState,
//                 state: "failed",
//                 message: payload?.message,
//                 error: payload?.error,
//             };
//         default:
//             return initialState;
//     }
// }
